import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks';
import './OfflineBanner.css';

function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="offline-banner">
      <WifiOff size={18} />
      <span>You're offline. Some features may be unavailable.</span>
    </div>
  );
}

export default OfflineBanner;
